import { NgcCookieConsentConfig } from 'ngx-cookieconsent';
import { environment } from '@env/environment';

export const cookieConsentConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: environment.cookies.domain,
  },
  palette: {
    popup: {
      background: '#fff',
    },
    button: {
      background: '#1158dc',
    },
  },
  showLink: false,
  theme: 'classic',
  type: 'info',
  content: {
    message: `
          <div class="cookie-title">Política de Cookies</div>
          <div class="cookie-text">
            Para tornar sua navegação mais fácil e segura, usamos cookies. Clique em 'ok' para continuar. Para mais detalhes, confira nossa 
             política de cookies <a href="politicas-e-termos/politica-de-cookies.html">clicando aqui</a>.
          </div>
        `,
    dismiss: 'OK',
  },
};
